export default {
    setAlert(texto, tipo){
        this.alert.texto = texto ? texto : null
        this.alert.tipo = tipo ? tipo : 'primary'
    },
    sendAlert(params){
        this.alert.texto = _.get(params, 'texto', '')
        this.alert.tipo = _.get(params, 'tipo', '')
        this.alert.titulo = _.get(params, 'titulo', null)
    },

    setLoading(texto, show){
        this.showLoading = show ? show : false
        this.textLoading = texto ? texto : null
    },
    isAutenticaded(){
        let token = localStorage.getItem('token')
        let refresh_token = localStorage.getItem('refresh_token')
        if(!_.isNull(this.$store.state.auth)){
            return true;
        }
        if(localStorage.getItem('fastLogin')){
            return false
        }
        if(token && refresh_token){
            return true
        }
        return false;
    },
    getUsuario(callbackSuccess, callbackError){
        if(localStorage.getItem('token')){
            this.$root.setLoading("Buscando dados do usuário", true)
            this.$resources.Usuario.get('').then((response) => {
                this.$store.dispatch('changeUser', response.data.data)
                if(_.isFunction(callbackSuccess)){
                    callbackSuccess()
                }
            }).catch((error) => {
                console.dir(error)
                this.clearUsuario()
                if(_.isFunction(callbackError)){
                    callbackError()
                }
            })
        }
    },
    setUsuario(data, callback){
        localStorage.setItem('token',         data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
        localStorage.setItem('expires',       data.expires)
        this.$store.dispatch('changeAuth',    data)
        this.$root.getUsuario(callback)
    },
    clearUsuario() {
        this.$store.dispatch('changeAuth', null)
        this.$store.dispatch('changeUser', null)
        this.$store.dispatch('changeCartaoVigente', null)
        this.$store.dispatch('changeCarrinho', [])
        //this.$cookie.delete('carrinho')
        localStorage.clear()
    },
    refreshToken() {
        if(this.isAutenticaded()){
            let serial = {
                grant_type: 'refresh_token',
                refresh_token: localStorage.getItem('refresh_token'),
                serial: null,
            }
            this.checkLocal(serial, () => {
                this.$root.setLoading("Autenticando usuário", true)
                this.$resources.OAuth.post('/', serial).then((response) => {
                    this.setUsuario(response.data.data, () => {
                        this.loadApp = true
                    })
                }).catch((error) => {
                    this.loadApp = true
                    console.dir(error)
                    this.clearUsuario()
                    this.clearCarrinho()
                    this.$router.push({name: 'autenticacao'})
                })
            })
        }
        else{
            if(localStorage.getItem('fastLogin')){
                this.$router.push({name: 'index'})
            }
            this.clearUsuario()
            this.loadApp = true
        }
    },
    checkLocal(valueSet, successFunction, errorFunction){
        this.$root.setLoading("Analisando permissões de acesso", true)
        this.$resources.OAuth.post('/', {
            grant_type: "local",
        }).then((response) => {
            valueSet.serial = response.data.data.serial
            if(_.isFunction(successFunction)){
                successFunction()
            }
        }).catch((error) => {
            console.dir(error)
            if(_.isFunction(errorFunction)){
                errorFunction()
            }
        })
    },
    cartaoVigente(callback, callbackError){
        this.setLoading("Buscando Informação sobre a carteira", true)
        this.$resources.CartaoVigente.get('').then((response) => {
            this.$store.dispatch('changeCartaoVigente', response.data.data)
            if(_.isFunction(callback)){
                callback()
            }
        }).catch((error) => {
            console.dir(error)
            if(_.isFunction(callbackError)){
                callbackError()
            }
            else if (error.response && error.response.data) {
                this.$root.setAlert(error.response.data.message, 'danger')
            }
        })
    },
    clearCarrinho() {
        this.$store.dispatch('changeCarrinho', [])
        localStorage.removeItem('carrinho')
        //this.$cookie.delete('carrinho')
    },
    setErrorForm(errors) {
        this.errorsForm = _.isObject(errors) && _.size(errors) ? errors : {}
    },
    redirectToRV(urlRedirect) {
        let token = localStorage.getItem('token')
        $(() => {
            console.info(token)
            let div = $('#form-transparent')
            div.empty()

            let form = $("<form />")
            form.attr('method','post')
            form.attr('target','_blank')
            form.attr('action',process.env.VUE_APP_ENDPOINT_URL + 'redevermelha/autenticacao/autenticar-externo')
            div.append(form)

            let input = $("<input />")
            input.attr('name', 'referer').attr('type', 'hidden')
            input.val(urlRedirect)
            form.append(input)

            input = $("<input />")
            input.attr('name', 'token').attr('type', 'hidden')
            input.val(token)
            form.append(input)

            form.submit()
        })
    },

    getUsuariosParaTeste() {
        if(_.isUndefined(process.env.USUARIOS_PARA_TESTE)) return [];
        return process.env.USUARIOS_PARA_TESTE.split(';')
    },

    eUmUsuarioParaTesteLogado() {
        let idUsuario = this.$store.getters.user ? this.$store.getters.user.pk_id_usuario : "0"
        return _.indexOf(this.getUsuariosParaTeste(), idUsuario) != -1
    },

    validateCPF (cpf) {
        cpf = cpf.replace(/\D/g, '');
        var numeros, digitos, soma, i, resultado, digitos_iguais;
        digitos_iguais = 1;
        if (cpf.length < 11)
            return false;
        for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1))
            {
                digitos_iguais = 0;
                break;
            }
        if (!digitos_iguais) {
            numeros = cpf.substring(0,9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--)
                soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;
            numeros = cpf.substring(0,10);
            soma = 0;
            for (i = 11; i > 1; i--)
                soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;
            return true;
        }
        else
            return false;
    },
}



// WEBPACK FOOTER //
// ./src/methods.js